/**
 * Debounce function to limit how often a function can be called
 * Returns a function with a cancel method for cleanup
 */
export const debounce = (func, wait) => {
  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }
  
  let timeout = null;
  
  const debounced = function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (typeof func === 'function') {
        try {
          func(...args);
        } catch (error) {
          if (import.meta.env.DEV) {
            console.error('Debounced function error:', error);
          }
        }
      }
    };
    
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait || 0);
  };
  
  debounced.cancel = () => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  return debounced;
};

/**
 * Throttle function to limit function execution rate
 */
export const throttle = (func, limit) => {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

